import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Layout } from "./components/Layout";
import { Toaster } from "./components/ui/sonner";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { RequireAuth } from "./components/RequireAuth";

// Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Vineyards from "./pages/Vineyards";
import VineyardDetail from "./pages/VineyardDetail";
import VineyardForm from "./pages/VineyardForm";
import Wines from "./pages/Wines";
import WineDetail from "./pages/WineDetail";
import WineForm from "./pages/WineForm";
import Favorites from "./pages/Favorites";
import Profile from "./pages/Profile";
import MapView from "./pages/MapView";
import WineCompare from "./pages/WineCompare";
import AdminDashboard from "./pages/AdminDashboard";
import Cellar from "./pages/Cellar";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Auth pages without layout */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Pages with layout */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/vineyards" element={<Layout><RequireAuth><Vineyards /></RequireAuth></Layout>} />
            <Route path="/map" element={<Layout><RequireAuth><MapView /></RequireAuth></Layout>} />
            <Route path="/vineyards/new" element={<Layout><RequireAuth><VineyardForm /></RequireAuth></Layout>} />
            <Route path="/vineyards/:id" element={<Layout><RequireAuth><VineyardDetail /></RequireAuth></Layout>} />
            <Route path="/vineyards/:id/edit" element={<Layout><RequireAuth><VineyardForm /></RequireAuth></Layout>} />
            <Route path="/wines" element={<Layout><RequireAuth><Wines /></RequireAuth></Layout>} />
            <Route path="/wines/new" element={<Layout><RequireAuth><WineForm /></RequireAuth></Layout>} />
            <Route path="/compare" element={<Layout><RequireAuth><WineCompare /></RequireAuth></Layout>} />
            <Route path="/wines/:id" element={<Layout><RequireAuth><WineDetail /></RequireAuth></Layout>} />
            <Route path="/wines/:id/edit" element={<Layout><RequireAuth><WineForm /></RequireAuth></Layout>} />
            <Route path="/favorites" element={<Layout><RequireAuth><Favorites /></RequireAuth></Layout>} />
            <Route path="/cellar" element={<Layout><RequireAuth><Cellar /></RequireAuth></Layout>} />
            <Route path="/admin" element={<Layout><RequireAuth><AdminDashboard /></RequireAuth></Layout>} />
            <Route path="/profile" element={<Layout><RequireAuth><Profile /></RequireAuth></Layout>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
